import { render, staticRenderFns } from "./FichasDePartidosSelector.vue?vue&type=template&id=6e83639a&scoped=true&"
import script from "./FichasDePartidosSelector.vue?vue&type=script&lang=js&"
export * from "./FichasDePartidosSelector.vue?vue&type=script&lang=js&"
import style0 from "./FichasDePartidosSelector.vue?vue&type=style&index=0&id=6e83639a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e83639a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
import { VTab } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
installComponents(component, {
  VIcon,
  VTab,
  VTabs,
  VToolbar,
})
